// extracted by mini-css-extract-plugin
export default {"expressCheckoutSection":"Uy-z","expressButtonContainerWithPayPal":"Vy-z","expressButton":"Wy-z","or":"Xy-z"};